import React from 'react';
import { capabilitiesData } from '../data/mock';

const Capabilities = () => {
  return (
    <section className="capabilities-section">
      <div className="container">
        <div className="capabilities-header">
          <h2 className="section-label">(Capabilities.)</h2>
        </div>

        <div className="capabilities-grid">
          {capabilitiesData.map((capability, index) => (
            <div key={index} className="capability-card">
              <h3 className="capability-title">{capability.title}</h3>
              <ul className="capability-list">
                {capability.items.map((item, idx) => (
                  <li key={idx} className="capability-item">
                    <span className="capability-bullet">—</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Capabilities;
